export default __webpack_public_path__ + "static/media/unnamed (13).1da90d12.jpeg";